<template>
  <el-card v-loading="loading">
    <section class="flex justify-bet wrap">
      <div class="flex wrap">
        <el-input
          style="width: 250px"
          class="mt-3 mr-5"
          v-model="input"
          placeholder="Merchant Name / Address"
          @keyup.enter.native="filterTable"
          @blur="filterTable"
          clearable
          @clear="filterTable"
          prefix-icon="el-icon-search"
        ></el-input>
        <el-date-picker
          v-model="date"
          class="mt-3"
          type="daterange"
          start-placeholder="Start"
          end-placeholder="End"
          value-format="timestamp"
          @change="filterTable"
          style="width: 250px"
        ></el-date-picker>
      </div>
      <vs-button
        @click="transactionListBlob"
        color="primary"
        size="small"
        type="border"
        class="mt-3"
        >Export</vs-button
      >
    </section>
    <el-table
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }"
      stripe
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column
        width="80"
        sortable
        prop="id"
        label="Id"
      ></el-table-column>
      <el-table-column
        prop="merchant_name"
        label="Merchant Name"
      ></el-table-column>
      <el-table-column show-overflow-tooltip prop="address" label="Address">
        <template slot-scope="scope">
          <span class="text-elli">{{ scope.row.address }}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="in_txid" label="Tx">
        <template slot-scope="scope">
          <span class="text-elli">{{ scope.row.in_txid }}</span>
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="balance"
        label="GrossAmount"
      ></el-table-column>
      <el-table-column sortable prop="fee" label="TxFee"></el-table-column>
      <el-table-column sortable prop="risk_level" label="Risk Level">
        <template slot-scope="scope">
          <span>{{ scope.row.risk_level|filterLevel }}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="net_amount" label="Net Amount">
      </el-table-column>
      <el-table-column
        sortable
        prop="create_time"
        label="Time"
      ></el-table-column>
      <!-- <el-table-column prop="pay_status" label="Pay Status">
        <template slot-scope="scope">
          <span
            :style="{
              color:
                scope.row.pay_status == 'Finished'
                  ? '#67C23A'
                  : scope.row.pay_status == 'Pending'
                  ? '#E6A23C'
                  : '409EFF',
            }"
            >{{ scope.row.pay_status }}</span
          >
        </template>
      </el-table-column> -->
      <el-table-column prop="status" label="Status">
        <template slot-scope="scope">
          <span
            :style="{
              color:
                scope.row.status == 'Finished'
                  ? '#67C23A'
                  : scope.row.status == 'Pending'
                  ? '#E6A23C'
                  : scope.row.status == 'In Progress'
                  ? '#409EFF'
                  : '#F56C6C',
            }"
            >{{ scope.row.status }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="Action" width="150">
        <template slot-scope="scope">
          <vs-button
            @click="showDialog(scope.row)"
            size="small"
            color="primary"
            type="border"
            >Details</vs-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="flex justify-bet mt-5">
      <div></div>
      <div class="flex justify-bet">
        <div class="mr-4">Sum of Gross:{{ total_usdt.toFixed(2) }}</div>
        <div class="mr-4">Sum of Fee:{{ sumFee.toFixed(2) }}</div>
        <div>Sum of Net :{{ sumNet.toFixed(2) }}</div>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="page"
        :pager-count="5"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <vs-popup title="Detail" :active.sync="dialogVisible">
      <el-row>
        <el-col :span="24">
          <ul class="detail-view">
            <li>
              <span>Name:</span>
              <span>{{ dialogData.merchant_name }}</span>
            </li>
            <li>
              <span>Address:</span>
              <span style="color: #67c23a">{{ dialogData.address }}</span>
            </li>
            <li>
              <span>Tx:</span>
              <span style="color: #67c23a">{{ dialogData.in_txid }}</span>
            </li>
            <li>
              <span>Risk Level:</span>
              <span>{{ dialogData.risk_level|filterLevel }}</span>
            </li>
            <li>
              <span>Price:</span>
              <span>{{ dialogData.sell_price }}</span>
            </li>
            <li>
              <span>Balance:</span>
              <span>{{ dialogData.balance }}</span>
            </li>
            <li>
              <span>USD:</span>
              <span>{{ dialogData.usd_balance }}</span>
            </li>
            <li>
              <span>Symbol:</span>
              <span>{{ dialogData.symbol }}</span>
            </li>
            <li>
              <span>Time:</span>
              <span>{{ dialogData.create_time }}</span>
            </li>
            <li>
              <span>Address Type:</span>
              <span>{{ dialogData.address_type }}</span>
            </li>
            <!-- <li>
              <span>Pay Status:</span>
              <span
                :style="{
                  color:
                    dialogData.pay_status == 'Finished'
                      ? '#67C23A'
                      : dialogData.pay_status == 'Pending'
                      ? '#E6A23C'
                      : '409EFF',
                }"
                >{{ dialogData.pay_status }}</span
              >
            </li> -->
            <li>
              <span>Status:</span>
              <span
                :style="{
                  color:
                    dialogData.status == 'Finished'
                      ? '#67C23A'
                      : dialogData.status == 'Pending'
                      ? '#E6A23C'
                      : dialogData.status == 'In Progress'
                      ? '#409EFF'
                      : '#F56C6C',
                }"
                >{{ dialogData.status }}</span
              >
            </li>
          </ul>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </vs-popup>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      input: "",
      date: "",
      tableData: [],

      dialogVisible: false,
      dialogData: {},
      size: 10,
      page: 1,
      total: 0,

      total_usdt: 0,
      sumFee: 0,
      sumNet: 0,
    };
  },
  filters:{
    filterLevel(val){
      return val == 0 ? "Waitting" : val == 1 ? 'Low' : val == 2 ? 'Middle' : val == 3 ? 'High' : val == 4 ?"Serious":"-"
    }
  },
  created() {
    this.defaultDate();
    this.getTable();
  },
  methods: {
    defaultDate() {
      let today = new Date(); //获取当天零点时间戳
      let month = today.getMonth(); //1,3,5,7,8,10,12
      let year = new Date().getFullYear();
      let day31 = [1, 3, 5, 7, 8, 10, 12];

      // 判断平年(28)闰年(29)
      let computedYear =
        (year % 4 == 0 && year % 100 != 0) || year % 400 == 0 ? 29 : 28;
      let day = day31.includes(month)
        ? 31
        : month == 2 && computedYear == 29
        ? 29
        : month == 2 && computedYear == 28
        ? 28
        : 30;
      let last = new Date(today.getTime() - day * 24 * 3600 * 1000).getTime();
      this.date = [last, today.getTime()];
    },
    filterTable() {
      this.page = 1;
      this.getTable();
    },
    getTable() {
      this.total_usdt = 0;
      this.sumFee = 0;
      this.sumNet = 0;
      this.$api
        .tronTokenTransaction({
          keywords: this.input,
          start_time: this.date ? this.date[0] : "",
          end_time: this.date ? this.date[1] + 86400000 : "",
          size: this.size,
          page: this.page,
        })
        .then((res) => {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
          res.data.data.data.forEach((item) => {
            this.total_usdt += Number(item.balance);
            this.sumFee += Number(item.fee);
            this.sumNet += Number(item.net_amount);
          });
          this.loading = false;
        });
    },
    transactionListBlob() {
      this.$api
        .tronTokenTransactionBlob({
          keywords: this.input,
          start_time: this.date ? this.date[0] : "",
          end_time: this.date ? this.date[1] + 86400000 : "",
          download_type: "tron_token_transaction",
        })
        .then((res) => {
          this.downLoadFile(res.data, "tron_token_transaction");
        });
    },
    showDialog(row) {
      this.dialogData = row;
      this.dialogVisible = true;
    },
    handleSizeChange(val) {
      this.size = val;
      this.getTable();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getTable();
    },
  },
};
</script>
<style lang="scss">
.detail-view {
  p {
    padding: 10px 20px;
    span {
      display: inline-block;
      font-weight: 700;
      width: 120px;
      text-align: right;
      // padding-right: 10px;
    }
  }
}
</style>
